// extracted by mini-css-extract-plugin
module.exports = {"colors":"\"../styles/_colors.css\"","foreground":"#ffffff","header":"Header_header__3mObx","logo":"Header_logo__2ins2"};